import { REMOVE_RULES } from '../constants'
import { toggleSelected } from '.'

export default indices => (dispatch, getState) => {
    const selected = getState().editorReducer.selected

    dispatch(
        toggleSelected(
            indices.filter(idx => selected.has(idx)),
            true
        )
    )

    dispatch({
        type: REMOVE_RULES,
        indices
    })
}
